import React, { useMemo, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { cryptoFooterItems, fiatFooterItems } from '../../helpers/constant';
import clsx from 'clsx';

const useFooterState = () => {
    const activeCurrencyPage = useSelector(state => state.juno.activeCurrencyPage);
    const { pathname } = useLocation();

    const footerContent = useMemo(
        () => (activeCurrencyPage === 'crypto' ? cryptoFooterItems : fiatFooterItems),
        [activeCurrencyPage],
    );

    const isItemActive = useCallback(itemPath => pathname === itemPath, [pathname]);

    return { footerContent, isItemActive };
};

const NavItem = React.memo(({ item, isActive }) => (
    <Link
        to={item.path}
        className={clsx(
            'flex items-center justify-center py-2 h-12 rounded-lg !text-text text-black relative transition-all',
            {
                'bg-card-bg border-b-2 border-b-color-primary': isActive,
            },
        )}>
        {item?.icon && (
            <svg
                className={clsx('w-6 h-auto', {
                    'fill-theme-color !text-text': isActive,
                })}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="!text-text">
                {item.icon}
            </svg>
        )}
    </Link>
));

NavItem.displayName = 'NavItem';

const Footer = () => {
    const { footerContent, isItemActive } = useFooterState();

    const gridColsClass = `grid-cols-${footerContent?.length || 3}`;

    return (
        <div className="fixed bottom-0 left-0 w-full bg-filterPannel-bg z-10 py-2 px-6 md:px-8">
            <div className={clsx('grid gap-4', gridColsClass)}>
                {footerContent.map(item => (
                    <NavItem key={item?.id} item={item} isActive={isItemActive(item?.path)} />
                ))}
            </div>
        </div>
    );
};

export default React.memo(Footer);
